"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var CheckoutButton = function (_a) {
    var _b = _a.sticky, sticky = _b === void 0 ? false : _b;
    return ((0, preact_1.h)("form", { class: sticky ? 'cart-section__sticky-cta' : '', action: "/cart?return_to=/checkout", method: "POST" },
        (0, preact_1.h)("input", { type: "submit", name: "checkout", value: "Proceed to Checkout", class: "button button--hot-orange cta" })));
};
exports.default = (0, compat_1.memo)(CheckoutButton);
